import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from '../../../shared/notifier/notifier.service';
import { HsMenuService } from '../../../services/hs-menu.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-side-menu-content',
  styleUrls: [
    './styles/side-menu-content.scss'
  ],
  templateUrl: './side-menu-content.component.html',
  encapsulation: ViewEncapsulation.None
})

export class SideMenuContentComponent {
  userMgmt: any = {};
  nombreUsuario = '';
  menuFunctions: Array<any> = [];

  constructor(private _router: Router, private notifierService: NotifierService,
    private hsMenuService: HsMenuService,){
    this.loadMenuOptions();
    this.notifierService.userMgmtObject$.subscribe((user) => {
      this.userMgmt = user;
      this.nombreUsuario = this.userMgmt.nombres + ' ' + this.userMgmt.apellidos;
    });
  }

  cerrarSesion() {
    localStorage.removeItem('jwt');
    localStorage.removeItem('nombreCompleto');
    localStorage.clear();
    this._router.navigate(['/public/login']);
  }

  loadMenuOptions() {
    this.hsMenuService.getMenu().subscribe(
      (result: Array<any>) => {
        this.menuFunctions = result;
      }, (error) => {
        console.log(error);
      })
  }

  legacyFunction(name) {
    console.log(name);
    switch (name) {
      case 'TimeSheet':
      //this._router.navigate(['/system/tiempo', { externalUrl: 'localhost:4300/#' }]);
      window.open(environment.TBWALEGACY_URL +
          '/#/system/tiempo/' +
          localStorage.getItem('jwt'),
          '_blank')
        break;
    
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/system/core/side-menu/content/side-menu-content.component.ts